import { useEventListener } from 'usehooks-ts';

const usePreventDataLoss = () => {
    const handler = (event: BeforeUnloadEvent) => {
        event.preventDefault();
        event.returnValue = true;
    };
    useEventListener('beforeunload', handler);
};
export default usePreventDataLoss;
